import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { OeAppPersonService } from '../shared/oe-app-person.service';
import { OeAppService } from '../shared/oe-app.service';
import { LiveClassScheduleDto } from '../shared/types/live-class-schedule-dto';
import { LiveClassDto, LiveClassServiceDto } from '../shared/types/LiveClassDto';
import { LiveClassHelpers } from './live-class.helpers';

@Injectable()
export class LiveClassService {

  private _hasPrivateClasses$ = new Subject<boolean>();
  public hasPrivateClasses$ = this._hasPrivateClasses$.asObservable();

  constructor(
    private http: HttpClient,
    private oeAppPersonService: OeAppPersonService,
    private oeAppService: OeAppService
  ) {}

  getInProgressLiveClassSchedules(): Observable<Array<LiveClassDto>> {
    const params = new HttpParams().set('personId', this.oeAppPersonService.id.toString());
    return this.http
      .get<Array<LiveClassServiceDto>>(`${this.oeAppService.oeLiveClassServiceHost}/v1/liveclasses/in-progress`, {
        params,
      })
      .pipe(
        map((liveClassSchedules: Array<LiveClassServiceDto>) =>
          LiveClassHelpers.convertLiveClassesArrayToDate(liveClassSchedules)
        )
      );
  }

  getRawCurrentLiveClassSchedules(): Observable<LiveClassServiceDto[]> {
    const params = new HttpParams().set('personId', this.oeAppPersonService.id.toString());
    return this.http.get<Array<LiveClassServiceDto>>(`${this.oeAppService.oeLiveClassServiceHost}/v1/liveclasses`, { params });
  }

  getCurrentLiveClassSchedules(): Observable<Array<LiveClassDto>> {
    return this.getRawCurrentLiveClassSchedules()
      .pipe(map((liveClassSchedules: Array<LiveClassServiceDto>) => {
        const hasPrivateClasses = this.checkForPrivateClasses(liveClassSchedules);
        this._hasPrivateClasses$.next(hasPrivateClasses);
        return LiveClassHelpers.convertLiveClassesArrayToDate(liveClassSchedules)
      }));
  }

  getHasPrivateClasses(): Observable<boolean> {
    return this.getRawCurrentLiveClassSchedules().pipe(map((liveClassSchedules: Array<LiveClassServiceDto>) => {
      return this.checkForPrivateClasses(liveClassSchedules);
    }))
  }

  getNextLiveClassSchedules(): Observable<Array<LiveClassDto>> {
    const params = new HttpParams().set('personId', this.oeAppPersonService.id.toString());
    return this.http
      .get<Array<LiveClassServiceDto>>(`${this.oeAppService.oeLiveClassServiceHost}/v1/liveclasses/next`, { params })
      .pipe(
        map((liveClassSchedules: Array<LiveClassServiceDto>) =>
          LiveClassHelpers.convertLiveClassesArrayToDate(liveClassSchedules)
        )
      );
  }

  requestLiveClass(liveClassScheduleId: number, lcLessonId: number) {
    return this.http.post(
     `${this.oeAppService.oeLiveClassServiceHost}/v1/liveclasses/requestliveclasses`,
      {
        personId: this.oeAppPersonService.id,
        liveClassScheduleId,
        lcLessonId,
      },
      {
        responseType: 'text',
      }
    );
  }

  getWeekLiveClassSchedules(): Observable<Array<LiveClassScheduleDto>> {
    const personId = this.oeAppPersonService.id;
    return this.http
      .get<Array<LiveClassScheduleDto>>(`${this.oeAppService.oeLiveClassServiceHost}/v1/liveclasses/week/${personId}`)
      .pipe(
        map((weekSchedules) => {
          weekSchedules.forEach((daySchedules) => {
            const date = new Date(daySchedules.date[0], daySchedules.date[1] - 1, daySchedules.date[2]).valueOf();
            daySchedules.date = date;
            daySchedules.liveClasses = _.uniqBy(daySchedules.liveClasses, (liveClass) => liveClass.title);
            daySchedules.liveClasses = daySchedules.liveClasses.sort((a, b) => a.order - b.order);
            daySchedules.liveClasses.forEach((liveClass) => {
              liveClass.classBegin = date;
            });
          });
          return weekSchedules;
        })
      );
  }

  private checkForPrivateClasses(liveClasses: LiveClassServiceDto[]): boolean {
    return liveClasses.some((liveClass) => liveClass.type === 'Private Class');
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class.service.ts